<template lang="pug"></template>

<script>
import language from '../../../../build/language/index.js'
import PATHS from '../../../router/routesMap.js'

export default {
  name: 'TrocaAplicacao',

  data () {
    return {
      isLogin: false
    }
  },

  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    }
  },

  methods: {
    login () {
      let lang = this.$route.query.idioma
      language.changeLanguage(lang)
      this.$store.dispatch('loginTrocaAplicacao', {token: this.$route.query.token}).then((response) => {
        this.$store.dispatch('getClients')
          .then((clients) => {
            this.$store.dispatch('getFuncionalities').then((response) => {
              this.$store.dispatch('saveAllowedFuncionalities', response.data.allowedFunc)
            })
            this.$store.dispatch('setClient', {client: response.cliente.id, clientName: response.cliente.nomeFantasia, singleClient: clients && clients.length === 1}).then((response) => {
              location.href = PATHS.HOME
            })
          })
          .catch((error) => {
            this.$store.dispatch('logout')
              .then(() => {
                this.$root.$refs.notification.error(error.message)
                this.$router.push(PATHS.LOGIN)
              })
          })
      }).catch((error) => {
        this.$store.dispatch('logout').then(() => {
          this.$root.$refs.notification.error(error.message)
          this.$router.push(PATHS.LOGIN)
        })
      })
    }
  },

  created () {
    this.login()
  }
}
</script>



// WEBPACK FOOTER //
// TrocaAplicacao.vue?3d44c1bf